import React from 'react';

export const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="container header-inner">
        <a href="#top" className="brand">
          <span className="brand-mark" aria-hidden="true" />
          RoadStatic
        </a>
        <nav className="nav">
          <a href="#features">Features</a>
          <a href="#how-it-works">How it works</a>
          <a href="#use-cases">Who it's for</a>
          <a href="#tech">Why not CB</a>
        </nav>
      </div>
    </header>
  );
};
